import React, { useEffect, useState } from 'react'
import { useRouteLoaderData, useNavigate } from 'react-router-dom'
import { Tabs, ConfigProvider, Image, Modal } from 'antd'

import LoginPassword from './LoginPassword'
import LoginPhone from './LoginPhone'
import Styles from './Login.module.scss'
import LoginTitleImg from '../../assets/images/logo.png'
import LoginBgLogoImg from '../../assets/images/login-bg-logo.png'
import { useSelector } from 'react-redux'
import { examinationAllocationReset } from '../../common/request'
import ResponseCode from '../../common/response-code'

const Login = () => {
  const navigate = useNavigate()
  const rootData = useRouteLoaderData('root')
  const envInfo = useSelector(state => state.env.envInfo)
  const [tabsItem] = useState([
    {
      key: '1',
      label: '账号密码登录',
      children: <LoginPassword/>
    },
    {
      key: '2',
      label: '手机验证码登录',
      children: <LoginPhone/>
    }
  ])

  useEffect(() => {
    if (rootData === 500) {
      navigate('/network-error', { replace: true })
    }

    sessionStorage.setItem('login-page', 'login')
  }, [])

  return (
    <ConfigProvider componentSize="large">
      <div className={ Styles.loginPage }>
        <div className={ Styles.logonWrap }>
          <div className={ 'mr-3' }>
            <div className={ Styles.loginTitle }>
              <Image preview={ false } src={ LoginTitleImg } width={ 32 } height={ 32 }></Image>
              <div className={ 'ml-3' }>{ envInfo.title || '中正公考人事考试服务平台' }</div>
            </div>
            <div className={ Styles.loginSubTitle }>后台管理系统</div>
            <div>
              <Image preview={ false } src={ LoginBgLogoImg } width={ 390 }></Image>
            </div>
          </div>
          <div className={ 'ml-5' }>
            <div className={ Styles.loginContainer }>
              <Tabs centered items={ tabsItem }></Tabs>
              <div className={ Styles.loginTip }>注意：其他人员没有账号请联系机构管理员。</div>
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  )
}

export default Login
